import React, { useEffect, useState, useRef } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { CSVLink } from "react-csv";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import {
  formatDate,
  formatDateWithTime,
  formatDateYYYYMMDD,
  ISODateString,
} from "../../utils/dateFormat";
import {
  roles,
  languageOptions,
  formatSpentValue,
  capitalizeFirstLetter,
} from "../../utils/constants";
import {
  SlButton,
  SlSelect,
  SlOption,
  SlIcon,
  SlInput,
  SlTooltip,
  SlIconButton,
  SlDrawer
} from "@shoelace-style/shoelace/dist/react";
import download_icon from "../../assets/images/download_icon 1.svg"
import hideTool from "../../assets/images/hide.png"


function PositionwiseImpressions(object) {
  const [data, setData] = useState([]);
  const [langId, setLangId] = useState("1");
  const [dateFilter, setDateFilter] = useState("");
  const [loader, setLoader] = useState(false);
  const [downloadData, setDownloadData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [activePos, setActivePos] = useState(-1);
  const [expaned, setExpaned] = useState(false)
  const [LogDetails, setLogDetails] = useState({})


  const navigate = useNavigate();

  const csvLinkRef = useRef(); // Create a ref for CSVLink
  const downloadcsvLinkRef = useRef(); // Create a ref for CSVLink
  let csvHeaders = [
    { label: "Position", key: "position" },
    { label: "National", key: "national" },
    { label: "Local", key: "local" },
    { label: "PanelTotal", key: "paneltotal"},
    { label: "Gam", key: "gam" },
    { label: "AdMob", key: "admob" },
    { label: "GamTotal", key: "gamtotal"},
    { label: "Backfill National", key: "backfillnational" },
    { label: "Backfill Local", key: "backfilllocal" },
    { label: "BackfillTotal", key: "backfilltotal"},
    { label: "Total", key: "total" },
    { label: "National Campaigns", key: "NationalCampaigns"},
    { label: "Local Campaigns", key: "LocalCampaigns"},
    { label: "Backfill National Campaigns", key: "BackfillNationalCampaigns"},
    { label: "Backfill Local Campaigns", key: "BackfillLocalCampaigns"},
    { label: "Ad Codes", key: "ad_codes" }
  ];

  useEffect(() => {
    if (downloadData.length) {
      csvLinkRef?.current?.link?.click();
      setDownloadData([]);
    }
  }, [downloadData]);


  let totalPanelNationalSum = 0,
    totalPanelLocalSum = 0,
    totalGamExSum = 0,
    totalAdmobSum = 0,
    totalBackfillNationalSum = 0,
    totalBackfillLocalSum = 0;

  const LanguageFilterChange = (e) => {
    setLangId(e.target.value);
  };

  const getdata = async (langId) => {
    setLoader(true);
    try {
      let res = await api({
        url: "/reports/date-positionwise-impressions",
        method: "POST",
        responseType: "json",
        data: {
          lang_id: langId,
          date: dateFilter,
        },
      });
      if (res.code === 200) {
        setData(res?.data);
      }
      setLoader(false);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  useEffect(() => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(yesterday.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    setDateFilter(formattedDate);
  }, []);

  useEffect(() => {
    if(langId && dateFilter)
      getdata(langId, dateFilter);
  }, [langId, dateFilter]);

  const generateCsv = async (data) => {
    try {
      let result = [];
      data.array.map(
        ({
          position,
          panel,
          backfill,
          gam,
          slots,
          ad_codes
        }) => {
          result.push({
            position,
            national: +panel.National || 0,
            local: +panel.Local || 0,
            gam: +gam.GAM_Imps || 0,
            admob: +gam.Admob_Imps || 0,
            backfillnational: +backfill.National || 0,
            backfilllocal: +backfill.Local || 0,
            paneltotal: +panel.Total || 0,
            gamtotal: +gam.Total || 0,
            backfilltotal: +backfill.Total || 0,
            total: (+panel.Total || 0) + (+gam.Total || 0) + (+backfill.Total || 0),
            NationalCampaigns: slots?.map(slot => {if(slot.slot !== 3){return slot.NationalCampaigns}else return []}).flat().join(', '),
            LocalCampaigns : slots?.map(slot => {if(slot.slot !== 3){return slot.LocalCampaigns}else return []}).flat().join(', '),
            BackfillNationalCampaigns : slots?.map(slot => {if(slot.slot === 3){return slot.NationalCampaigns}else return []}).flat().join(', '),
            BackfillLocalCampaigns : slots?.map(slot => {if(slot.slot === 3){return slot.LocalCampaigns}else return []}).flat().join(', '),
            ad_codes: ad_codes.join(', ')
          });
        }
      );
      result.push({
        position: "Total",
        national: +data.totalPanel.National || 0,
        local: +data.totalPanel.Local || 0,
        gam: +data.totalGam.GAM_Imps || 0,
        admob: +data.totalGam.Admob_Imps || 0,
        backfillnational: +data.totalBackfill.National || 0,
        backfilllocal: +data.totalBackfill.Local || 0,
        paneltotal: +data.totalPanel.Total || 0,
        gamtotal: +data.totalGam.Total || 0,
        backfilltotal: +data.totalBackfill.Total || 0,
        total: (+data.totalPanel.Total || 0) + (+data.totalGam.Total || 0) + (+data.totalBackfill.Total || 0),
        NationalCampaigns: [],
        LocalCampaigns :[],
        BackfillNationalCampaigns : [],
        BackfillLocalCampaigns : [],
        ad_codes: []
      });
      setDownloadData(result);
    } catch (error) {
      console.error("Error @ generateCsv", error);
    }
  };

  const getPositionColors = (array) => {
    try {
      let circles = array.map((posItem) => {
        let colors = {
          pn: posItem?.panel?.National,
          pl: posItem?.panel?.Local,
          gm: posItem?.gam?.GAM_Imps,
          am: posItem?.gam?.Admob_Imps,
          bn: posItem?.backfill?.National,
          bl: posItem?.backfill?.Local,
        };
        let count = 0;
        Object.keys(colors).map((item) => {
          
          if (colors[item]) {
            ++count;
          }
        });
        let equalpercent = (100 / count).toFixed(2),
          currenPercent = 0;
        let style = "linear-gradient(to right,";

        if (colors.pn) {
          currenPercent += +equalpercent;
          style = style + `#4ECA03 ${currenPercent}%,`;
          if (+equalpercent === 100) {
            style = "#4ECA03";
          }
        }
        if (colors.pl) {
          if (currenPercent !== 0) {
            style = style + `#2563EB ${currenPercent}%,`;
          }
          currenPercent += +equalpercent;
          style = style + `#2563EB ${currenPercent}%,`;
          if (+equalpercent === 100) {
            style = "#2563EB";
          }
        }
        if (colors.gm) {
          if (currenPercent !== 0) {
            style = style + `#D58E00 ${currenPercent}%,`;
          }
          currenPercent += +equalpercent;
          style = style + `#D58E00 ${currenPercent}%,`;
          if (+equalpercent === 100) {
            style = "#D58E00";
          }
        }
        if (colors.am) {
          if (currenPercent !== 0) {
            style = style + `#9301C0 ${currenPercent}%,`;
          }
          currenPercent += +equalpercent;
          style = style + `#9301C0 ${currenPercent}%,`;
          if (+equalpercent === 100) {
            style = "#9301C0";
          }
        }
        if (colors.bn) {
          if (currenPercent !== 0) {
            style = style + `#4ECA03 ${currenPercent}%,`;
          }
          currenPercent += +equalpercent;
          style = style + `#4ECA03 ${currenPercent}%,`;
          if (+equalpercent === 100) {
            style = "#4ECA03";
          }
        }
        if (colors.bl) {
          if (currenPercent !== 0) {
            style = style + `#2563EB ${currenPercent}%,`;
          }
          currenPercent += +equalpercent;
          style = style + `#2563EB ${currenPercent}%,`;
          if (+equalpercent === 100) {
            style = "#2563EB";
          }
        }
        if (+equalpercent !== 100) {
          style = style.slice(0, -1);
          style = style + `)`;
        }
        // console.log(style)
        return (
          <li
            onClick={() => {scrollToSection(`pos-${posItem?.position}`); setActivePos(posItem?.position)}}
            style={{
              background: `${style}`
            }}

          >
            {posItem.position}
          </li>
        );
      });
      return circles;
    } catch (error) {
      console.error("Error @ getPositionColors", error);
    }
  };

  const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
  };

  const getLogs = async(params) => {
    try {
      let {slots, position, ad_codes} = params
      let res = await api({
        url: "/reports/datePositionwiseLogs",
        method: "POST",
        responseType: "json",
        data: {
          lang_id: langId,
          date: dateFilter,
          slots,
          position
        },
      });
      if(res.code === 200){
        let NationalCampaigns = slots?.map(slot => {if(slot.slot !== 3){return slot.NationalCampaigns}else return []}).flat();
        let LocalCampaigns = slots?.map(slot => {if(slot.slot !== 3){return slot.LocalCampaigns}else return []}).flat();
        let BackfillNationalCampaigns = slots?.map(slot => {if(slot.slot === 3){return slot.NationalCampaigns}else return []}).flat();
        let BackfillLocalCampaigns = slots?.map(slot => {if(slot.slot === 3){return slot.LocalCampaigns}else return []}).flat();
        let campaign_names = {NationalCampaigns, LocalCampaigns, BackfillNationalCampaigns, BackfillLocalCampaigns}
        setLogDetails({...res.data, campaign_names, ad_codes, position})
      }
    } catch (error) {
      console.error("Error @ getLogs" , error)
    }
  }

  return (
    <div className= "positionWise bgGray">
        <div>
          <CSVLink
            data={downloadData.map(
              ({
                position,
                national,
                local,
                gam,
                admob,
                backfillnational,
                backfilllocal,
                total,
                paneltotal,
                gamtotal,
                backfilltotal,
                NationalCampaigns,
                LocalCampaigns,
                BackfillNationalCampaigns,
                BackfillLocalCampaigns,
                ad_codes
              }) => {
                return {
                  position,
                  national,
                  local,
                  gam,
                  admob,
                  backfillnational,
                  backfilllocal,
                  total,
                  paneltotal,
                  gamtotal,
                  backfilltotal,
                  NationalCampaigns,
                  LocalCampaigns,
                  BackfillNationalCampaigns,
                  BackfillLocalCampaigns,
                  ad_codes
                };
              }
            )}
            headers={csvHeaders}
            filename={"campaign_reports.csv"}
            ref={csvLinkRef} // Assign the ref to the CSVLink component
          ></CSVLink>
        </div>
        <div className="d-flex justify-between mb-2 mt-2">
          <div className="d-flex gap-2">
            <SlSelect
              placeholder="Select Language"
              name="lang"
              size="medium"
              onSlChange={LanguageFilterChange}
              value={langId}
            >
              <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
              {/* <SlOption value="-1">All</SlOption> */}
              {languageOptions.map((item) => {
                return (
                  <SlOption key={item.value} value={item.value}>
                    {item.label}
                  </SlOption>
                );
              })}
            </SlSelect>

            <SlInput
              className="w-full"
              size="medium"
              type="date"
              placeholder="Date"
              onSlInput={(e) => {
                setDateFilter(e.target.value);
              }}
              style={{ width: "230px" }}
              value={dateFilter}
            />
          </div>
          {/* <div className="mr-6">
            <SlTooltip content="Download Reports">
              <SlIconButton
                library="lucide"
                name="download"
                onClick={() => {
                  generateCsv(data.array);
                }}
              ></SlIconButton>
            </SlTooltip>
          </div> */}
        </div>

        

<div class="impressions-container">
        {data?.array?.length ? (
            <div className="posList">
              <ul>
                {getPositionColors(data?.array).map((item) => item)}
              </ul>
            </div>
          ) : null}
          <div class="impressions-body bg-gray">
            {data?.array?.length && !loader ? (
              data?.array?.map((item) => {
                return (
                  <div class={"imp-card " + (activePos === item?.position ? 'active' : "")} id={`pos-${item?.position}`}  onClick={() => {getLogs(item)}}>
                    <div class="head">
                      <p>
                        Position: <b>#{item?.position}</b>
                      </p>
                      <h1
                        data-toggle="tooltip"
                        data-placement="top"
                        title={
                          item?.panel?.Total +
                          +item?.gam?.Total +
                          +item?.backfill?.Total
                        }
                      >
                        <span>Total</span>
                        {formatSpentValue(
                          item?.panel?.Total +
                            +item?.gam?.Total +
                            +item?.backfill?.Total
                        )}
                      </h1>
                    </div>
                    <div class="indvidual-count">
                      <div class="tHead">
                        <h6>Panel/GAM Internal Ads</h6>
                        <h6>GAM Network Ads</h6>
                        <h6>Backfill</h6>
                      </div>
                      <div class="tBody">
                        <p
                          data-toggle="tooltip"
                          data-placement="top"
                          title={item?.panel?.Total}
                        >
                          {formatSpentValue(item?.panel?.Total)}
                        </p>
                        <p
                          data-toggle="tooltip"
                          data-placement="top"
                          title={item?.gam?.Total}
                        >
                          {formatSpentValue(item?.gam?.Total)}
                        </p>
                        <p
                          data-toggle="tooltip"
                          data-placement="top"
                          title={item?.backfill?.Total}
                        >
                          {formatSpentValue(item?.backfill?.Total)}
                        </p>
                      </div>
                      <div class="tCount">
                        <ul>
                          <li
                            class="nat-count"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.panel?.National}
                          >
                            National: {formatSpentValue(item?.panel?.National)}
                          </li>
                          <li
                            class="loc-count"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.panel?.Local}
                          >
                            Local: {formatSpentValue(item?.panel?.Local)}
                          </li>
                        </ul>
                        <ul>
                          <li
                            class="gam-count"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.gam?.GAM_Imps}
                          >
                            GAM Ext: {formatSpentValue(item?.gam?.GAM_Imps)}
                          </li>
                          <li
                            class="admob-count"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.gam?.Admob_Imps}
                          >
                            Admob: {formatSpentValue(item?.gam?.Admob_Imps)}
                          </li>
                        </ul>
                        <ul>
                          <li
                            class="nat-count"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.backfill?.National}
                          >
                            National:{" "}
                            {formatSpentValue(item?.backfill?.National)}
                          </li>
                          <li
                            class="loc-count"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.backfill?.Local}
                          >
                            Local: {formatSpentValue(item?.backfill?.Local)}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : !data?.array?.length && !loader ? (
              <div className="noData"><NoDataFound /></div>
            ) : (
              <TableLoader colspan="15" />
            )}
          </div>
      </div>
      
      <div class="impressions-footer">
            <div class="checkToggle">
              <input type="checkbox" name="toggle" id="cToggle" checked = {expaned} onClick={() => {setExpaned(!expaned)}}/>
              <label for="cToggle">
                <span>Show Totals</span>{" "}
                <img src={hideTool} alt="logo" />
                &nbsp;
              </label>
            </div>
            <div class={ "footerTotals" + (expaned ? " expanded" : " Notexpanded")}>
              <h6>Total:</h6>
              <div class="count-list">
                <p>Panel/GAM Internal Ads</p>
                <h1
                  data-toggle="tooltip"
                  data-placement="top"
                  title={data?.totalPanel?.Total}
                >
                  {formatSpentValue(data?.totalPanel?.Total)}
                </h1>
                <ul>
                  <li
                    class="nat-count"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={data?.totalPanel?.National}
                  >
                    <span>National:</span>{" "}
                    {formatSpentValue(data?.totalPanel?.National)}
                  </li>
                  <li
                    class="loc-count"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={data?.totalPanel?.Local}
                  >
                    <span>Local:</span>{" "}
                    {formatSpentValue(data?.totalPanel?.Local)}
                  </li>
                </ul>
              </div>
              <div class="count-list">
                <p>GAM Network Ads</p>
                <h1
                  data-toggle="tooltip"
                  data-placement="top"
                  title={data?.totalGam?.Total}
                >
                  {formatSpentValue(data?.totalGam?.Total)}
                </h1>
                <ul>
                  <li
                    class="gam-count"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={data?.totalGam?.GAM_Imps}
                  >
                    <span>GAM External:</span>{" "}
                    {formatSpentValue(data?.totalGam?.GAM_Imps)}
                  </li>
                  <li
                    class="admob-count"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={data?.totalGam?.Admob_Imps}
                  >
                    <span>Admob:</span>{" "}
                    {formatSpentValue(data?.totalGam?.Admob_Imps)}
                  </li>
                </ul>
              </div>
              <div class="count-list">
                <p>Backfill</p>
                <h1
                  data-toggle="tooltip"
                  data-placement="top"
                  title={data?.totalBackfill?.Total}
                >
                  {formatSpentValue(data?.totalBackfill?.Total)}
                </h1>
                <ul>
                  <li
                    class="nat-count"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={data?.totalBackfill?.National}
                  >
                    <span>National:</span>
                    {formatSpentValue(data?.totalBackfill?.National)}
                  </li>
                  <li
                    class="loc-count"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={data?.totalBackfill?.Local}
                  >
                    <span>Local:</span>
                    {formatSpentValue(data?.totalBackfill?.Local)}
                  </li>
                </ul>
              </div>
              <div class="total-count">
                <h5>
                  Total
                  <br />
                  Impressions
                </h5>
                <h1
                  data-toggle="tooltip"
                  data-placement="top"
                  title={
                    data?.totalPanel?.Total +
                    +data?.totalGam?.Total +
                    +data?.totalBackfill?.Total
                  }
                >
                  {formatSpentValue(
                    data?.totalPanel?.Total +
                      +data?.totalGam?.Total +
                      +data?.totalBackfill?.Total
                  )}
                </h1>
              </div>
              <button class="btn-download" onClick={() => generateCsv(data)}>
                <img src={download_icon} alt="" />{" "}
                <span>Download Reports</span>
              </button>
            </div>
          </div>

          {<SlDrawer
                label={`Update Logs of position ${LogDetails.position}`}
                style={{ '--size': `${window.innerWidth <= 767 ? '100vw' : '50vw' }` }}
                open={Object.keys(LogDetails)?.length}
                onSlAfterHide={() => { setLogDetails({}); }}
            >
              {LogDetails?.campaign_names && Object.keys(LogDetails?.campaign_names)?.length ? <>
                <h5 className="text-center mt-2">Panel Ads</h5>
              <div className=" campaign_names">
                <div className="each_div">
                <h6>National Lineitems</h6>
                <ul>
                {(LogDetails.campaign_names?.NationalCampaigns?.length ? LogDetails.campaign_names?.NationalCampaigns : ['-'])?.map(item => <li><span>{item}</span></li>)}
                </ul>
                </div>
                <div className="each_div">
                <h6>Local Lineitems</h6>
                <ul>
                {(LogDetails.campaign_names?.LocalCampaigns?.length ? LogDetails.campaign_names?.LocalCampaigns : ['-']) ?.map(item => <li><span>{item}</span></li>)}
                </ul>
                </div>
                <div className="each_div">
                <h6>Backfill Lineitems</h6>
                <h8 className='font-bold text-xs'>National</h8>
                <ul>
                {(LogDetails.campaign_names?.BackfillNationalCampaigns?.length ?  LogDetails.campaign_names?.BackfillNationalCampaigns : ['-'])?.map(item => <li><span>{item}</span></li>)}
                </ul>
                <h8  className='font-bold text-xs'>Local</h8>
                <ul>
                {(LogDetails.campaign_names?.BackfillLocalCampaigns?.length ? LogDetails.campaign_names?.BackfillLocalCampaigns : ['-'])?.map(item => <li><span>{item}</span></li>)}
                </ul>
                </div>
                {/* <div className="each_div">
                <h6>Backfill Local Lineitems</h6>
                <ul>
                {LogDetails?.slots?.map(slot => {if(slot.slot === 3){return slot.LocalCampaigns}}).flat()?.map(item => <li><span>{item}</span></li>)}
                </ul>
              </div> */}
              <div className="each_div">
                <h6>Gam External Ad codes</h6>
                <ul>
                {(LogDetails?.ad_codes?.length ?  LogDetails?.ad_codes : ['-']) ?.map(item => <li><span>{item}</span></li>)}
                </ul>
              </div>
                </div></>
                : null}
                {LogDetails?.GamExtLogs && Object.keys(LogDetails?.GamExtLogs)?.length ?  <>
                  <h5 className="text-center mt-2">Gam External Ads Logs</h5>
                <div className="overflow-x-auto">
                    <table className="table table-bordered compLogs">
                        <thead>
                            <tr>
                                <th className="row-span-2">Name</th>
                                <th  className="row-span-2">Time</th>
                                <th className="splThead">
                                    <table>
                                        <tr>
                                            <th colspan="3">Details</th>
                                        </tr>
                                        <tr>
                                            <th>Type</th>
                                            <th>Previous</th>
                                            <th>Updated</th>
                                        </tr>
                                    </table>
                                </th>                                
                            </tr>
                        </thead>
                        {Object.keys(LogDetails?.GamExtLogs)?.length ? <tbody>
                            {LogDetails?.GamExtLogs?.map((item) => {
                                return (
                                    <tr className={`row-span-${item.log.length}`}>
                                        <td>{capitalizeFirstLetter(item.user_name)}</td>
                                        <td>{formatDateWithTime(item.updatetime)}</td>
                                        <td colspan="3" className="splTdata">
                                            <table>
                                            {item.log.map(upItem => {
                                            return(<tr>
                                                <td>{upItem.type}</td>
                                                <td>{upItem.previous || "-"}</td>
                                                <td>{upItem.updated || "-"}</td>
                                                </tr>)
                                            })}
                                            </table>
                                            </td>                                        
                                    </tr>
                                )
                            })}
                        </tbody> : <NoDataFound></NoDataFound>}
                    </table>
                </div> </>: null }
                {((LogDetails?.GamExtLogs && !Object.keys(LogDetails?.GamExtLogs)?.length) && (LogDetails?.campaign_names && !Object.keys(LogDetails?.campaign_names)?.length)) ? <div className="noData"><NoDataFound /></div> : null}
            </SlDrawer>}
    </div>
  );
}

export default PositionwiseImpressions;

{
  /* <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Position</th>
              <th scope="col">Panel/GAM Internal Ads</th>
              <th scope="col">GAM Network Ads</th>
              <th scope="col">Backfill </th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          {data?.array?.length && !loader ? (
            <tbody>
              {data?.array?.map((item, index) => {
                totalPanelNationalSum += +item?.nationalImps;
                totalPanelLocalSum += +item?.localImps;
                totalGamExSum += item?.GAM_Imps || 0;
                totalAdmobSum += +(item?.Admob_Imps || 0);

                totalBackfillNationalSum += item?.nationlaBackFill;
                totalBackfillLocalSum += +item?.localbackFill;
                return (
                  <tr key={item._id}>
                    <td>{item?.position}</td>
                    <td>
                      <div
                        className="posImpressions"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={item?.nationalImps + item?.localImps}
                      >
                        <b>
                          {formatSpentValue(
                            item?.nationalImps + item?.localImps
                          )}{" "}
                        </b>
                        <div>
                          <span
                            className="nationalImp"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.nationalImps}
                          >
                            National: {formatSpentValue(item?.nationalImps)}
                          </span>
                          <span
                            className="localImp"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.localImps}
                          >
                            Local: {formatSpentValue(item?.localImps)}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        className="posImpressions"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={(item?.Admob_Imps || 0) + (item?.GAM_Imps || 0)}
                      >
                        <b>
                          {formatSpentValue(
                            (item?.Admob_Imps || 0) + (item?.GAM_Imps || 0)
                          )}{" "}
                        </b>
                        <div>
                          <span
                            className="gamImp"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.GAM_Imps || 0}
                          >
                            GAM External:{" "}
                            {formatSpentValue(item?.GAM_Imps || 0)}
                          </span>
                          <span
                            className="admobImp"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.Admob_Imps || 0}
                          >
                            Admob : {formatSpentValue(item?.Admob_Imps || 0)}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        className="posImpressions"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={item?.nationlaBackFill + item?.localbackFill}
                      >
                        <b>
                          {formatSpentValue(
                            item?.nationlaBackFill + item?.localbackFill
                          )}{" "}
                        </b>
                        <div>
                          <span
                            className="nationalImp"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.nationlaBackFill}
                          >
                            National: {formatSpentValue(item?.nationlaBackFill)}
                          </span>
                          <span
                            className="localImp"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={item?.localbackFill}
                          >
                            Local: {formatSpentValue(item?.localbackFill)}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        className="posImpressions"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={
                          (+item?.nationalImps || 0) +
                          (+item?.localImps || 0) +
                          (+item?.Admob_Imps || 0) +
                          (+item?.GAM_Imps || 0) +
                          (+item?.nationlaBackFill || 0) +
                          (+item?.localbackFill || 0)
                        }
                      >
                        {formatSpentValue(
                          (+item?.nationalImps || 0) +
                            (+item?.localImps || 0) +
                            (+item?.Admob_Imps || 0) +
                            (+item?.GAM_Imps || 0) +
                            (+item?.nationlaBackFill || 0) +
                            (+item?.localbackFill || 0)
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td>
                  <b>Total</b>
                </td>
                <td>
                  <div
                    className="posImpressions"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={+totalPanelNationalSum + +totalPanelLocalSum}
                  >
                    <b>
                      {formatSpentValue(
                        +totalPanelNationalSum + +totalPanelLocalSum
                      )}
                    </b>
                    <div>
                      <span
                        className="nationalImp"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={totalPanelNationalSum}
                      >
                        National: {formatSpentValue(totalPanelNationalSum)}
                      </span>
                      <span
                        className="localImp"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={totalPanelLocalSum}
                      >
                        Local: {formatSpentValue(totalPanelLocalSum)}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    className="posImpressions"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={+totalGamExSum + +totalAdmobSum}
                  >
                    <b>{formatSpentValue(+totalGamExSum + +totalAdmobSum)}</b>
                    <div>
                      <span
                        className="gamImp"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={+totalGamExSum || 0}
                      >
                        GAM External: {formatSpentValue(+totalGamExSum || 0)}
                      </span>
                      <span
                        className="admobImp"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={+totalAdmobSum || 0}
                      >
                        Admob: {formatSpentValue(+totalAdmobSum || 0)}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    className="posImpressions"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={+totalBackfillNationalSum + +totalBackfillLocalSum}
                  >
                    <b>
                      {formatSpentValue(
                        +totalBackfillNationalSum + +totalBackfillLocalSum
                      )}
                    </b>
                    <div>
                      <span
                        className="nationalImp"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={+totalBackfillNationalSum}
                      >
                        National: {formatSpentValue(+totalBackfillNationalSum)}
                      </span>
                      <span
                        className="localImp"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={+totalBackfillLocalSum}
                      >
                        Local: {formatSpentValue(+totalBackfillLocalSum)}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    className="posImpressions"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={
                      +totalPanelNationalSum +
                      +totalPanelLocalSum +
                      +totalGamExSum +
                      +totalAdmobSum +
                      +totalBackfillNationalSum +
                      +totalBackfillLocalSum
                    }
                  >
                    <b>
                      {formatSpentValue(
                        +totalPanelNationalSum +
                          +totalPanelLocalSum +
                          +totalGamExSum +
                          +totalAdmobSum +
                          +totalBackfillNationalSum +
                          +totalBackfillLocalSum
                      )}
                    </b>
                  </div>
                </td>
              </tr>
            </tbody>
          ) : !data?.array?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table> */
}




      // <div className="posImpTable">
      // {data?.array?.length ? (
      //       <div className="d-flex gap-2 block circles">
      //         {getPositionColors(data?.array).map((item) => item)}
      //       </div>
      //     ) : null}

      // <div className="posImpbody">
      //     <div className="card">
            
      //     </div>
      //     <div className="card">

      //     </div>
      //     <div className="card">

      //     </div>
      //     <div className="card">

      //     </div>
      // </div>
      // <div className="footerBorder">
      //   <div className="footer">
      //   <h6>Total</h6>
      //   <span className="straightLine"></span>
      //     <div className="footerDiv">
      //       <p >Panel/GAM InternalAds</p>
      //       <h1>6.91M</h1>
      //       <ul className="p-0 m-0  d-flex gap-2">
      //       <li className="nationaltext">National: 3.59M</li>
      //       <li className="localtext  ">Loal: 3.23M</li>
      //       </ul>         
      //        </div>
      //        <span className="straightLine"></span>
      //     <div  className="footerDiv">
      //       <p >Gam Network Ads</p>
      //       <h1>6.91M</h1>
      //       <ul  className="p-0 m-0  d-flex gap-2">
      //       <li className="gamtext  ">National: 3.59M</li>
      //       <li className="admobtext">Loal: 3.23M</li>
      //       </ul>      
      //     </div>
      //     <span className="straightLine"></span>
      //     <div  className="footerDiv">
      //     <p >Backfill</p>
      //       <h1>6.91M</h1>
      //       <ul  className="p-0 m-0 d-flex gap-2">
      //       <li className="nationaltext">National: 3.59M</li>
      //       <li className="localtext">Loal: 3.23M</li>
      //       </ul>  
      //     </div>
      //     <div className="footerTotal d-flex justify-between items-center">
      //       <span>Total <br/> Impressions</span>
      //       <h1>45.22M</h1>
      //     </div>
      //   </div>         
      // </div>
      // </div>
